
import capaWelcomeChipp from "../../img/capaDubbing/capaWelcomeChipp.webp";
import capaTheRihteous from "../../img/capaDubbing/capaTheRihteous.webp";
import capaPride from "../../img/capaDubbing/capaPride.webp";
import capaTheChi from "../../img/capaDubbing/capaTheChi.webp";
import capaTheOrville from "../../img/capaDubbing/capaTheOrville.webp";
import capaItsWonderful from "../../img/capaDubbing/capaItsWonderful.webp";
import capaHipHopUnc from "../../img/capaDubbing/capaHipHopUnc.webp";
import capaMrInBetween from "../../img/capaDubbing/capaMrInBetween.webp";
import capaEdgeOf from "../../img/capaDubbing/capaEdgeOf.webp";
import capaDamelioShow from "../../img/capaDubbing/capaDamelioShow.webp";
import capaForensic from "../../img/capaDubbing/capaForensic.webp";
import capaLaetitia from "../../img/capaDubbing/capaLaetitia.webp";
import capaDopesick from "../../img/capaDubbing/capaDopesick.webp";
import capaConversationWithFriends from "../../img/capaDubbing/capaConversationWithFriends.webp";
import capaReservationDogs from "../../img/capaDubbing/capaReservationDogs.webp";
import capaLesAmateurs from "../../img/capaDubbing/capaLesAmateurs.webp";
import capaFireIsland from "../../img/capaDubbing/capaFireIsland.webp";
import capaMalconInTheMiddle from "../../img/capaDubbing/capaMalconInTheMiddle.webp";
import capaRookieCops from "../../img/capaDubbing/capaRookieCops.webp";
import capaBlackNarcissus from "../../img/capaDubbing/capaBlackNarcissus.webp";
import capaCandy from "../../img/capaDubbing/capaCandy.webp";
import capaTheOldMan from "../../img/capaDubbing/capaTheOldMan.webp";
import capaCrazyLove from "../../img/capaDubbing/capaCrazyLove.webp";
import capaImpuros from "../../img/capaDubbing/capaImpuros.webp";
import capaHowICaught from "../../img/capaDubbing/capaHowICaught.webp";
import capaGoodTrouble from "../../img/capaDubbing/capaGoodTrouble.webp";
import capaSmallMight from "../../img/capaDubbing/capaSmallMight.webp";
import capaResanobleDoubt from "../../img/capaDubbing/capaResanobleDoubt.webp";
import capaInsecure from "../../img/capaDubbing/capaInsecure.webp";
import capaIronMike from "../../img/capaDubbing/capaIronMike.webp";
import capaKissSixth from "../../img/capaDubbing/capaKissSixth.webp";
import capaATeacher from "../../img/capaDubbing/capaATeacher.webp";
import capaMatriach from "../../img/capaDubbing/capaMatriach.webp";
import capaAnitaMui from "../../img/capaDubbing/capaAnitaMui.webp";
import capaSitiados from "../../img/capaDubbing/capaSitiados.webp";
import capaUnsolvedMysteries from "../../img/capaDubbing/capaUnsolvedMysteries.webp";
import capaValente from "../../img/capaDubbing/capaValente.webp";
import capaAmericanRescue from "../../img/capaDubbing/capaAmericanRescue.webp";
import capaBreeders from "../../img/capaDubbing/capaBreeders.webp";
import capaBuffy from "../../img/capaDubbing/capaBuffy.webp";
import capaDelicacies from "../../img/capaDubbing/capaDelicacies.webp";
import capaGhost from "../../img/capaDubbing/capaGhost.webp";
import capaHacker from "../../img/capaDubbing/capaHacker.webp";
import capaHysterical from "../../img/capaDubbing/capaHysterical.webp";
import capaInsania from "../../img/capaDubbing/capaInsania.webp";
import capaJustifyCity from "../../img/capaDubbing/capaJustifiedCity.webp";
import capaSuccession from "../../img/capaDubbing/capaSuccession.webp";
import capaVictoriaSecrets from "../../img/capaDubbing/capaVictoriaSecret.webp";
import capaWillTrent from "../../img/capaDubbing/capaWillTrent.webp";
import capaMotherTeresa from "../../img/capaDubbing/capaMotherTeresa.webp";
import capaRingo from "../../img/capaDubbing/capaRingo.webp";
import capaTierra from "../../img/capaDubbing/capaTierraIncog.webp";





const imgCapaDubbing = [
    {
        id: 1,
        name: "Welcome To Chippeddales",
        alt: "poster Welcome To Chippeddales",
        img: capaWelcomeChipp,
    },

    {
        id: 3,
        name: "The Rihteous GemStones",
        alt: "capa The Rihteous GemStones",
        img: capaTheRihteous
    },

    {
        id: 4,
        name: "Pride",
        alt: "capa Pride",
        img: capaPride
    },

    {
        id: 5,
        name: "The Chi",
        alt: "capa The Chi",
        img: capaTheChi
    },

    {
        id: 6,
        name: "The Orville",
        alt: "capa The Oriville",
        img: capaTheOrville
    },

    {
        id: 7,
        name: "Its A Wonderful Binge ",
        alt: "capa Its A Wonderful Binge",
        img: capaItsWonderful
    },

    {
        id: 8,
        name: "Hip Hop Uncovered",
        alt: "capa Hip Hop Uncovered",
        img: capaHipHopUnc
    },

    {
        id: 9,
        name: "Mr In Between",
        alt: "capa Mr In Between",
        img: capaMrInBetween
    },

    {
        id: 10,
        name: "Edge Of The Earth",
        alt: "capa Edge Of The Earth",
        img: capaEdgeOf
    },

    {
        id: 11,
        name: "D'Amelio Show",
        alt: "capa D'Amelio Show",
        img: capaDamelioShow
    },

    {
        id: 12,
        name: "Forensic File",
        alt: "capa Forensic Files",
        img: capaForensic 
    },

    {
        id: 13,
        name: "Laetitia",
        alt: "capa Laetitia",
        img: capaLaetitia
    },

    {
        id: 14,
        name: "Dopesick",
        alt: "capa Dopesick",
        img: capaDopesick
    },

    {
        id: 15,
        name: "Conversation With Friends",
        alt: "capa Conversation With Friends",
        img: capaConversationWithFriends
    },

    {
        id: 16,
        name: "Reservation Dogs",
        alt: "capa Reservation Dogs",
        img: capaReservationDogs
    },

    {
        id: 17,
        name: "Les Amateurs",
        alt: "capa Les Amateurs",
        img: capaLesAmateurs
    },

    {
        id: 18,
        name: "Fire Island",
        alt: "capa Fire Island",
        img: capaFireIsland
    },

    {
        id: 19,
        name: "Malcon In The Middle",
        alt: "capa Malcon In The Middle",
        img: capaMalconInTheMiddle
    },

    {
        id: 20,
        name: "Rookie Cops",
        alt: "capa Rookie Cops",
        img: capaRookieCops
    },

    {
        id: 21,
        name: "Black Narcissus",
        alt: "capa Black Narcissus",
        img: capaBlackNarcissus
    },

    {
        id: 22,
        name: "Candy",
        alt: "capa Candy" ,
        img: capaCandy
    },

    {
        id: 23,
        name: "The Old Man",
        alt: "capa The Old Mand",
        img: capaTheOldMan
    },

    {
        id: 24,
        name: "Crazy Love",
        alt: "capa Crazy Love",
        img: capaCrazyLove
    },

    {
        id: 25,
        name: "Impuros",
        alt: "capa Impuros",
        img: capaImpuros
    },

    {
        id: 26,
        name: "How I Caught My Killer",
        alt: "capa How I Caught My Killer",
        img: capaHowICaught
    },

    {
        id: 27,
        name: "Good Trouble",
        alt: "capa Good Trouble",
        img: capaGoodTrouble
    },

    {
        id: 28,
        name: "Small Might",
        alt: "capa Small Might",
        img: capaSmallMight
    },

    {
        id: 29,
        name: "Reasonable Doubt",
        alt: "capa Resanoble Doubt",
        img: capaResanobleDoubt
    },

    {
        id: 30,
        name: "Insecure",
        alt: "capa Insecure",
        img: capaInsecure
    },

    {
        id: 31,
        name: "Iron Mike",
        alt: "capa Iron Mike",
        img: capaIronMike
    },

    {
        id: 32,
        name: "Kiss SixthSense",
        alt: "capa Kiss SixthSense",
        img: capaKissSixth
    },

    {
        id: 33,
        name: "A Teacher",
        alt: "capa A Teacher",
        img: capaATeacher
    },

    {
        id: 34,
        name: "Matriach",
        alt: "capa Matriarch",
        img: capaMatriach
    },

    {
        id: 35,
        name: "Anita Mui",
        alt: "capa Anita Mui",
        img: capaAnitaMui
    },

    {
        id: 36,
        name: "Sitiados",
        alt: "capa Sitiados",
        img: capaSitiados
    },

    {
        id: 37,
        name: "Unsolved Mysteries",
        alt: "capa Unsolved Mysteries",
        img: capaUnsolvedMysteries
    },

    {
        id: 38,
        name: "Valente",
        alt: "capa Valente",
        img: capaValente
    },

    {
        id: 39,
        name: "American Rescue DogShow",
        alt: "capa America Rescue DogShoe",
        img: capaAmericanRescue
    },

    {
        id: 40,
        name: "Breeders",
        alt: "capa Breeders",
        img: capaBreeders
    },

    {
        id: 41,
        name: "Buffy",
        alt: "capa Buffy",
        img: capaBuffy
    },

    {
        id: 42,
        name: "Delicacies Destiny",
        alt: "capa Delicacies Destiny",
        img: capaDelicacies
    },

    {
        id: 42,
        name: "Ghost Whisperer",
        alt: "capa Ghost Whisperer",
        img: capaGhost
    },

    {
        id: 43,
        name: "Hacker",
        alt: "capa Hacker",
        img: capaHacker
    },

    {
        id: 44,
        name: "Hysterical",
        alt: "capa Hysterical",
        img: capaHysterical
    },

    {
        id: 45,
        name: "Insania",
        alt: "capa Insania",
        img: capaInsania
    },

    {
        id: 46,
        name: "Justify City Primeval",
        alt: "capa Justify City Primeval",
        img: capaJustifyCity
    },

    {
        id: 47,
        name: "Succession",
        alt: "capa Succession",
        img: capaSuccession
    },

    {
        id: 48,
        name: "Victoria Secrets",
        alt: "capa Victoria Secrets",
        img: capaVictoriaSecrets
    },

    {
        id: 49,
        name: "Will Trent",
        alt: "capa Will Trent",
        img: capaWillTrent
    },

    {
        id: 50,
        name: "Mother Teresa",
        alt: "capa Mother Teresa",
        img: capaMotherTeresa
    },

    {
        id: 51,
        name: "Ringo",
        alt: "capa Ringo",
        img: capaRingo
    },

    {
        id: 52,
        name: "Tierra Incognita",
        alt: "capa Tierra Incognita",
        img: capaTierra
    },
]

export default imgCapaDubbing